import React from 'react'
import './cancellations-tab-center-gutter.css'
import { format } from "date-fns"

const semestersOptions = ['Fall', 'Spring', 'Summer']
const chipStyles = (total) => {
    if(total < 3) {
        return {backgroundColor: '#DBEAFE', color: '#3B82F6'}
    } else if (total === 3) {
        return {backgroundColor: '#FFEDD5', color: '#F97316'}
    } else {
        return {backgroundColor: '#FEE2E2', color: '#EF4444'}
    }
}

const CancellationsTabCenterGutter = ({cancellations}) => {
    const [sortedCancellations, setSortedCancellations] = React.useState([])
    const [semesters, setSemesters] = React.useState([])

    React.useEffect(() => {
        sortCancellations()
    }, [])

    React.useEffect(() => {
        addSemesterToSemesters()
    }, [sortedCancellations])

    const sortCancellations = () => {
        let organizedCancellations = cancellations.sort((a, b) => {
            let dateA = new Date(a.dateTime)
            let dateB = new Date(b.dateTime)
            return dateB - dateA
        })
        addSemesterToEachCancellation(organizedCancellations)
    }

    const addSemesterToEachCancellation = (orgCancellations) => {
        let cancellationsWithSemester = orgCancellations.map(cancellation => {
            let date = new Date(cancellation.dateTime)
            let month = date.getMonth()
            let year = date.getFullYear()
            let semester = ''
            if(month >= 0 && month <= 4) {
                semester = `${semestersOptions[1]} ${year}`
            } else if(month >= 5 && month <= 7) {
                semester = `${semestersOptions[2]} ${year}`
            } else if(month >= 8 && month <= 11) {
                semester = `${semestersOptions[0]} ${year}`
            }
            return {...cancellation, semester}
        })
        setSortedCancellations(cancellationsWithSemester)
    }

    const addSemesterToSemesters = () => {
        let newSemesters = []
        let eachSemesterTally = {}
        sortedCancellations.forEach(cancellation => {
            if(!cancellation.teacherCancelled) {
                eachSemesterTally[cancellation.semester] = eachSemesterTally[cancellation.semester] ? eachSemesterTally[cancellation.semester] + 1 : 1
            }
            if(!newSemesters.includes(cancellation.semester)) {
                newSemesters.push(cancellation.semester)
            }
        })
        setSemesters(eachSemesterTally)
    }


    return (
        <div className="cancellations-tab-center-gutter__wrapper">
            {Object.keys(semesters).map((semester, index) => (
                <div key={index} className='cancellations-tab-center-gutter__semester-wrapper'>
            <div className='family-info-tab-center-gutter__top-label__wrapper'>
                <div className='family-info-tab-center-gutter__top-label__line'></div>
                <div className='family-info-tab-center-gutter__top-label__words cancellations-tab-center-gutter__semester-words'>{semester} 
                    <span className='family-info-tab-center-gutter__total-cancellations-semester-chip' style={chipStyles(semesters[semester])}>{semesters[semester]}</span>
                </div>
                <div className='family-info-tab-center-gutter__top-label__line'></div>
            </div>
                    {sortedCancellations.map((cancellation, index) => (
                        cancellation.semester === semester &&
                        <div key={index} style={index % 2 ? {backgroundColor: '#fff'} : {backgroundColor: 'rgb(248, 250, 252)'}} className="cancellations-tab-center-gutter__each-row">
                            <div className='cancellations-tab-center-gutter__student-name'>{cancellation.studentName} {cancellation.familyName}</div>
                            <div className='cancellations-tab-center-gutter__dob'>{format(new Date(cancellation.dateTime), 'MM/d/yy')}</div>
                            <div className='cancellations-tab-center-gutter__chip-wrapper'>{cancellation.teacherCancelled ? 
                                <div className='cancellations-tab-center-gutter__teacher-chip'>Teacher</div> : 
                                (cancellation.lessThan24Hours ? 
                                    <div className='cancellations-tab-center-gutter__less-than-chip'>{`Student <24 hrs`}</div> : 
                                    <div className='cancellations-tab-center-gutter__student-chip'>Student</div>
                                )}</div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}
export default CancellationsTabCenterGutter